<template>
<div></div>
</template>

<script>
import Vue from 'vue';
import { LoadingService } from '@/services';
import { EventBus } from '@/event-bus';

export default Vue.extend({
  name: 'LoadingPage',
  beforeRouteEnter(to, from, next) {
    if (to.path.startsWith('/online-application')) {
      next();
      return;
    }
    const loadingPromises = new Promise((resolve, reject) => {
      setTimeout(reject, 30000);
    });
    return LoadingService.watchPromises(loadingPromises)
      .then(next)
      .catch(() => {
        EventBus.$emit('openModal', 'Error', {
          message: 'global_connection-error',
          hideCancel: true,
        });
        EventBus.$emit('initialLoadDone');
      });
  },
  mounted() {
    if (this.$route.path.startsWith('/online-application')) {
      window.location.replace(this.$options.filters.t('submit-app-redirect'));
    }
  },
});
</script>
